import { Avatar, Badge, Dropdown, Flex, Space, Tag, Tooltip, Typography } from "antd"

import { ButtonComponent } from "../../../../Components/Button"
import Private from "../../../../Components/Private"
import Icon from "../../../../Icon"
import Images from "../../../../Images"
import {
  ensureHttps,
  paymentProcessorMap,
  statusTextMap,
  tagColorMap,
  tagMap
} from "../../../../Utils/utils"

const { Text, Link } = Typography

export const columns = (onSelectRow, t, theme, isDemoModeBlocked, incognito, isAdminViewingUser) => [
  {
    key: "name",
    title: t("Business account"),
    dataIndex: "name",
    fixed: "left",
    render: (_, record) => {
      if (isAdminViewingUser) {
        return _ ? (
          <Flex gap={4}>
            <Text copyable={{ tooltips: false, text: _ }} />
            <Dropdown
              destroyPopupOnHide={true}
              menu={{
                items: [
                  { key: "business_account", label: "Business account" },
                  { key: "dashboard", label: "Users view" }
                ],
                onClick: ({ key, domEvent }) => {
                  domEvent?.stopPropagation()
                  onSelectRow(record.id, key)
                }
              }}
            >
              <Flex gap={8} align="center">
                <Text className="blue">
                  <Private>{_}</Private>
                </Text>
                <Icon type="chevron_down_small" style={{ marginLeft: -4 }} />
              </Flex>
            </Dropdown>
          </Flex>
        ) : (
          "—"
        )
      }
      return (
        <Space size={12}>
          <Avatar
            size={24}
            src={record?.photo}
            style={{
              backgroundColor: record?.photo ? "transparent" : "#225AEA",
              borderRadius: "8px",
              border: "none",
              fontSize: 12
            }}
            {...(record?.photo && { src: record?.photo })}
          >
            {!record?.photo ? record?.name?.[0] || "" : null}
          </Avatar>
          <Text strong>{_}</Text>
        </Space>
      )
    }
  },
  {
    key: "url",
    title: t("Business URL"),
    dataIndex: "url",
    render: (url) =>
      incognito ? (
        // No href while masked - a real link would still leak the URL via hover preview/copy.
        <Link>
          <Private>{url}</Private>
        </Link>
      ) : (
        <Link href={ensureHttps(url)} target="_blank">
          {url}
        </Link>
      )
  },
  {
    key: "connected_payment_processors",
    title: t("Payment processor"),
    dataIndex: "connected_payment_processors",
    render: (_, record) => (
      <Avatar.Group size="small">
        {_?.length ? (
          _?.map((el) => (
            <Tooltip title={paymentProcessorMap[el] || el} key={el}>
              <Avatar src={Images[`integration_${el}`]} style={{ borderRadius: 8 }} />
            </Tooltip>
          ))
        ) : (
          <Tooltip title={isAdminViewingUser ? null : "Add payment processor"}>
            <Avatar
              icon={
                <Icon
                  type={theme === "dark" ? "add_account_dark" : "add_account"}
                  style={{ fontSize: 22 }}
                />
              }
              style={{ borderRadius: 8, cursor: isAdminViewingUser ? "not-allowed" : "pointer" }}
              onClick={
                isAdminViewingUser
                  ? undefined
                  : () => onSelectRow(record.id, "add_payment_processor")
              }
            />
          </Tooltip>
        )}
      </Avatar.Group>
    )
  },
  {
    key: "card",
    title: t("Credit card"),
    dataIndex: "card",
    render: (card) => (
      <Space>
        {card?.brand && (
          <img src={Images[`${card?.brand}${theme === "dark" ? "_dark" : ""}`]} alt={card?.brand} />
        )}
        {card?.["last4"] && (
          <>
            <Text>••••</Text>
            <Text>{card?.["last4"]}</Text>
          </>
        )}
      </Space>
    ),
    width: 140
  },
  {
    key: "status",
    title: t("Status"),
    dataIndex: "status",
    width: 140,
    render: (_, { status }) => {
      return (
        <Tag
          color={tagMap[status?.toLowerCase()] || "default"}
          key={status}
          style={{ margin: 0 }}
          className={"simple large"}
        >
          <Flex gap={8} align="center">
            <Badge
              status={tagMap[status?.toLowerCase()] || "default"}
              color={tagColorMap[status]}
            />
            <Text>{statusTextMap[status] || status}</Text>
          </Flex>
        </Tag>
      )
    }
  },
  {
    key: "action",
    title: "",
    align: "right",
    width: 80,
    render: (_, record) => {
      const handleAction = (e, data, type) => {
        e.preventDefault()
        e.stopPropagation()
        onSelectRow(data, type)
      }

      return (
        <Tooltip title={t("Business settings")}>
          <ButtonComponent
            type="text"
            shape="circle"
            icon={<Icon type={"edit_big"} />}
            onClick={(e) => handleAction(e, record.id, "business_settings")}
            className="flex center table-action-btn"
            style={{ fontSize: 20, marginLeft: "auto" }}
            disabled={isDemoModeBlocked}
          />
        </Tooltip>
      )
    }
  }
]
